import { createStyles } from "@mantine/emotion";

export default createStyles ( theme => ( {
	shareComponentContainer: {
		display: "flex"
	},
	svgContainer: {
		padding      : "0.5rem",
		borderRadius : "50%",
		display      : "flex",
		alignItems   : "center",
		cursor       : "pointer"
	},
	shareSvg: {
		width  : "40px",
		height : "40px"
	}
} ) );
